/**
 * Utilitários para tratamento de erros
 */

/**
 * Extrai mensagem de erro de forma segura
 * Prioriza o campo 'message' da resposta da API sobre outras mensagens
 */
export function getErrorMessage(error: unknown): string {
  if (typeof error === 'object' && error !== null) {
    // Priorizar mensagem da resposta da API (erros do Axios)
    if ('response' in error) {
      const axiosError = error as { response?: { data?: { message?: string } } };
      if (axiosError.response?.data?.message) {
        return axiosError.response.data.message;
      }
    }
    // Se não tiver response, verificar se tem message diretamente no objeto
    if ('message' in error) {
      return String(error.message);
    }
  }
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  return 'Erro desconhecido';
}

/**
 * Verifica se o erro é do tipo Axios
 */
export function isAxiosError(error: unknown): error is { response?: { data?: { message?: string }; status?: number } } {
  return typeof error === 'object' && error !== null && 'response' in error;
}

